import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../shared/HubLayout.css';
import SubNav from '../layout/SubNav';
import { useMobileSubNav } from '../layout/MobileNavContext';
import { useHubScreen } from '../layout/useHubScreen';
import { useEffect } from 'react';
import Billing from '../billing/Billing';
import Ranches, { RanchesActions } from '../ranch-settings/ranches/Ranches';
import SectionDescription from '../shared/SectionDescription';

const SUB_PATHS = ['billing', 'ranches'];

const AccountHub = () => {
  const { t } = useTranslation();
  const { subTab, screen, setScreen } = useHubScreen();
  const navigate = useNavigate();
  const { setSubNav } = useMobileSubNav();

  const activeSubTab = Math.max(0, SUB_PATHS.indexOf(subTab));

  const subTabs = [t('billing'), t('ranches')];
  const handleSubTabClick = (index) => navigate(`/account/${SUB_PATHS[index]}`);

  useEffect(() => {
    setSubNav({ tabs: subTabs, activeTab: activeSubTab, onTabClicked: handleSubTabClick });
    return () => setSubNav(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSubTab, setSubNav]);

  return (
    <div className="hub">
      <div className="hub-header">
        <SubNav tabs={subTabs} activeTab={activeSubTab} onTabClicked={handleSubTabClick} />
        <div className="hub-actions">
          {activeSubTab === 1 && <RanchesActions screen={screen} setScreen={setScreen} />}
        </div>
      </div>
      <div className="hub-content">
        {activeSubTab === 1 && (
          <SectionDescription
            title={t('ranches_section_title')}
            text={t('ranches_section_text')}
          />
        )}
        {activeSubTab === 0 && <Billing />}
        {activeSubTab === 1 && <Ranches screen={screen} setScreen={setScreen} hideHeader />}
      </div>
    </div>
  );
};

export default AccountHub;
